export default __webpack_public_path__ + "static/media/medallaoro_casco.96efa3bc.png";